export const MICROSITE_APPROVED_DOMAINS_CONTROL = 'microsite-approved-domains-control';
export const MICROSITE_APPROVED_DOMAINS_DUPLICATE = 'microsite-approved-domains-duplicate-error';
export const MICROSITE_APPROVED_DOMAINS_DUPLICATE_MESSAGE = 'This approved domain is already defined';
export const MICROSITE_APPROVED_DOMAINS_EXISTS = 'microsite-approced-domains-exists-error';
